import React from 'react';
import classNameBind from 'classnames/bind';
import moment from 'moment';

import styles from './DateTimeSelector.module.css';
import { DateSelector } from './DateSelector';
import { useTranslation } from '../../Translator';
import { TimeSelector } from '../../TimePicker/TimeSelector';
import { useBlur } from '../../../hooks/useBlur';
import Divider from '../../Divider/Divider';
import Button from '../../Button';
import Stack from '../../Stack';

const bindClasses = classNameBind.bind(styles);

const DateTimeSelector = ({
  name,
  min,
  max,
  onBlur,
  disabled,
  is12HourFormat,
  popoverClose,
  showClearActionButton,
  currDateTime,
  setPrevDateTime,
  setCurrentDateTime,
  prevDateTime,
  yearsSelectorRange,
}) => {
  const { t } = useTranslation('components');
  const { ref, handleBlur } = useBlur({ name, value: currDateTime, onBlur, disabled });

  return (
    <div className={bindClasses('outer-wrapper')}>
      <div
        className={bindClasses('wrapper')}
        data-ppuc-id="DateTimeSelector"
        ref={ref}
        onBlur={() => handleBlur(currDateTime)}
      >
        <DateSelector
          className={bindClasses('date-selector')}
          value={currDateTime ? [currDateTime] : []}
          yearsSelectorRange={yearsSelectorRange}
          min={min}
          max={max}
          onChange={(e) => {
            const newValue = e.target.value.length === 1 ? e.target.value[0] : e.target.value[1];

            if (currDateTime) {
              newValue.setHours(currDateTime.getHours());
              newValue.setMinutes(currDateTime.getMinutes());
              newValue.setSeconds(currDateTime.getSeconds());
            }

            setCurrentDateTime(newValue);
          }}
        />
        <TimeSelector
          value={currDateTime || new Date()}
          onChange={(e) => {
            setCurrentDateTime(e.target.value);
          }}
          is12HourFormat={is12HourFormat}
        />
      </div>
      <div className={bindClasses('action-buttons')}>
        <div className={bindClasses('divider-wrapper')}>
          <Divider noMargin />
        </div>
        <div className={bindClasses('buttons-wrapper')}>
          <Stack spacing="narrow">
            <Stack.Item fill>
              {showClearActionButton && (
                <Button
                  dataId="DateTimeSelector.clear"
                  text={t('clear')}
                  appearance="simple"
                  disabled={!currDateTime}
                  onClick={() => {
                    setPrevDateTime(currDateTime);
                    setCurrentDateTime(null);
                  }
                }
                />
              )}
            </Stack.Item>
            <Stack.Item>
              <Button
                dataId="DateTimeSelector.cancel"
                text={t('cancel')}
                onClick={() => {
                  setCurrentDateTime(prevDateTime);
                  setPrevDateTime(prevDateTime);
                  popoverClose();
                }}
              />
            </Stack.Item>
            <Stack.Item>
              <Button
                dataId="DateTimeSelector.apply"
                appearance="primary"
                text={t('apply')}
                disabled={moment(prevDateTime).isSame(moment(currDateTime))}
                onClick={() => {
                  setPrevDateTime(currDateTime);
                  setCurrentDateTime(currDateTime);
                  popoverClose();
                }}
              />
            </Stack.Item>
          </Stack>
        </div>
      </div>
    </div>
  );
};

DateTimeSelector.defaultProps = {
  onBlur: () => {},
};

export { DateTimeSelector };
